import { Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ProviderIcon } from 'screens/Calendar/WeekViewV2/CalendarEventCard/Icon'
import { Button } from 'blaze-ui/Button'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { BrandPlanTactic } from 'types'
import { VIDEO_TACTICS } from './utils'
import { TACTIC_TO_PROVIDER } from 'screens/blaze/Home/VirtualMarketerHome/Brain/PlatformSection/Types'
import { Key, useEffect, useState } from 'react'

export interface StrategyVideoDropdownProps {
  strategy: StrategyType
  onUpdate: (strategy: StrategyType) => void
  isDisabled?: boolean
}

export const StrategyVideoDropdown = ({ strategy, onUpdate, isDisabled }: StrategyVideoDropdownProps) => {
  const [tactics, setTactics] = useState<BrandPlanTactic[]>(
    strategy.tactics.filter((tactic) => VIDEO_TACTICS.includes(tactic)),
  )

  useEffect(() => {
    setTactics(strategy.tactics.filter((tactic) => VIDEO_TACTICS.includes(tactic)))
  }, [strategy.tactics])

  return (
    <MenuTrigger placement="bottom-end" popoverClassName={Styles.popover}>
      <Button variant="secondary" withChevron="down" className={Styles.channelsButton} isDisabled={isDisabled}>
        {(tactics.length > 0 ? tactics : VIDEO_TACTICS).map((tactic) => (
          <ProviderIcon
            key={tactic}
            provider={TACTIC_TO_PROVIDER.find((t) => t.tactic === tactic)?.provider as ExternalIntegrationEnum}
            size={16}
            isHovered={false}
            zIndex={0}
            borderColor="rgba(247, 247, 247, 1)"
            marginLeft={1}
            isReels={tactic === BrandPlanTactic.InstagramReel}
          />
        ))}
      </Button>
      <Menu
        aria-label="Menu"
        onAction={(key: Key) => {
          const newTactic = key as BrandPlanTactic

          if (tactics.includes(newTactic) && tactics.length === 1) {
            return
          }

          const newTactics = strategy.tactics.includes(newTactic)
            ? strategy.tactics.filter((tactic) => tactic !== newTactic) // Remove the tactic if it's already selected
            : [...strategy.tactics, newTactic] // Add the tactic if it's not already selected

          setTactics(newTactics.filter((tactic) => VIDEO_TACTICS.includes(tactic)))
          onUpdate({
            ...strategy,
            tactics: newTactics,
          })
        }}
        showCheckmark
        selectionMode="multiple"
        selectedKeys={new Set(tactics)}
        disabledKeys={tactics.length === 1 ? [tactics[0]] : undefined}
      >
        <Item key="instagram_reel" textValue="Reels" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.Instagram} size={16} isHovered={false} marginLeft={0} />
          Reels
        </Item>
        <Item key="tiktok" textValue="TikTok" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.TikTok} size={16} marginLeft={0} />
          TikTok
        </Item>
        <Item key="youtube" textValue="YouTube" data-close-on-select={false}>
          <ProviderIcon provider={ExternalIntegrationEnum.YouTube} size={16} marginLeft={0} />
          YouTube
        </Item>
      </Menu>
    </MenuTrigger>
  )
}
